import React, { Component } from 'react';
import { Input } from 'reactstrap';
class Enum extends Component {
    render() {
        return (<Input
            type='select'
            disabled={this.props.disabled}
            value={this.props.value}
            onChange={evt => {
                let val = evt.target.value;
                if (val === '') val = null;
                if (this.props.onChange) {
                    this.props.onChange(val);
                }
            }}>
            <option value=''>Không chọn</option>
            {this.props.schema.items.map((item, index) =>
                <option value={item.value} key={index}>{item.key}</option>)}
        </Input>)
    }
}

export default Enum;